var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 348.25 408.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #57ad83;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #53757a;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.65,0c3.97,6.72,7.94,13.44,12.07,20.43-29.23,19.54-45.44,46.78-45.43,82.07,0,35.29,16.2,62.54,45.59,82.18-4.28,6.88-8.39,13.5-12.64,20.32-11.74-7.21-21.72-15.88-30.15-26.3C6.94,153.79-2.11,125.15.41,93.36,3.42,55.36,21.09,25.29,52.22,3.2c1.35-.96,2.56-2.13,3.83-3.2h1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.39,0c4.64,3.67,9.45,7.14,13.9,11.03,27.57,24.08,42.06,54.48,41.96,91.1-.12,43.2-18.85,76.85-54.41,101.23-.75.52-1.59.91-2.69,1.54-4.18-6.73-8.3-13.34-12.58-20.23,29.39-19.64,45.59-46.9,45.59-82.18s-16.04-62.34-45.43-82.02c4.06-6.89,8.06-13.68,12.07-20.47h1.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.24,408.61c2.3-8.55,4.53-16.85,6.77-25.15,2.93-10.88,5.95-21.75,8.74-32.67.64-2.51,1.68-3.36,4.3-3.35,48.82.08,97.64.06,146.46.05,1.91,0,3.49-.13,4.16,2.46,4.92,18.86,10.01,37.68,15.02,56.52.17.62.1,1.31.16,2.15H81.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.33,151.01c-26.76.08-48.6-21.52-48.74-48.2-.15-26.77,21.68-48.79,48.53-48.96,26.46-.16,48.62,21.81,48.74,48.35.12,26.91-21.58,48.73-48.53,48.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.41,323.58H104.16c4.64-17.21,9.17-34.05,13.82-51.3h3.95c34.99,0,69.98.04,104.96-.07,3.04,0,4.27.75,5.05,3.86,3.82,15.17,7.98,30.26,12.01,45.38.16.6.26,1.22.45,2.12h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.52,248.1c6.87-25.49,13.67-50.69,20.53-76.14.99-.09,2.02-.27,3.04-.27,17.56-.02,35.11,0,52.67-.03,1.94,0,3.32-.03,3.99,2.56,6.33,24.25,12.87,48.44,19.33,72.65.1.36.06.76.09,1.22h-99.66.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.14,131.9c-4.27,6.86-8.33,13.39-12.65,20.33-15.5-9.96-24.85-23.72-27.14-41.69-3.06-24.02,6.54-44.06,27.12-57.76,4.17,6.69,8.34,13.38,12.64,20.3-10.39,7.15-16.26,16.79-16.22,29.46.03,12.51,5.7,22.12,16.25,29.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.99,52.7c18.32,12.2,27.91,28.97,27.71,50.41-.2,20.93-9.77,37.28-27.69,49.19-4.31-6.92-8.42-13.52-12.52-20.12,22.14-14.93,20.77-45.35-.07-59.18,4.09-6.6,8.19-13.22,12.57-20.3h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.e991804bf468ce27f802a41841f4cd19.svg";
export { ForwardRef as ReactComponent };